import moment from 'moment';

const timeZone = 'America/New_York';

export const dstRemover = (datetime) => {
  const givenDate = new Date(datetime);
  const isDST = moment(givenDate)
    .isDST();
  const modifiedDate = moment(givenDate)
    .clone()
    .add(1, 'hour');
  if (isDST) {
    return givenDate;
  }
  return new Date(modifiedDate);
};

export const formatToClockTimeForList = (datetime) => new Date(datetime)
  .toLocaleString('en-US', {
    timeZone,
    year: 'numeric',
    month: 'long',
    day: '2-digit',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });

export const formatToClockTime = (datetime) => new Date(datetime)
  .toLocaleString('en-US', {
    timeZone,
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });

export const formatTo = (datetime, format) => moment(datetime)
  .format(format);

export const formatDatetime = (datetime) => moment(datetime)
  .format('MMMM Do YYYY, h:mm a');

export const formatDatetimeExport = (datetime) => moment(datetime)
  .format('l LT');

export const datesAreSame = (date1, date2) => date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth() && date1.getDate() === date2.getDate();

// must be used for any datetime that has yyyy-MM-dd date format.
// It changes the date format to safari compatible but maintains the timezone. otherwise results in invalid date
export const formattedDate = (time) => {
  const dateArr = time.split(' ');
  return `${dateArr[0].replace(/-/g, '/')} ${dateArr[1]} ${dateArr[2]}`;
};
